import { useLazyGetQuery } from "slices/api";

export const useLazyGetOtherBillingReportsByUtilityId = () => {
  const [getOtherBillingReport, data] = useLazyGetQuery();
  const billingReports = async (query = {}) =>
    await getOtherBillingReport(
      {
        endpoint: "/report/other-utility-billing-report",
        query,
      },
      true
    ).unwrap();
  return [billingReports, data];
};

export const useLazyGetOtherBillingInvoiceReportByUtilityId = () => {
  const [getOtherBillingReport, data] = useLazyGetQuery();
  const billingReports = async (query = {}) =>
    await getOtherBillingReport(
      {
        endpoint: "/report/other-utility-einvoice-report",
        query,
      },
      true
    ).unwrap();
  return [billingReports, data];
};

export const useLazyGetDcsAdditionalReport = () => {
  const [getOtherBillingReport, data] = useLazyGetQuery();
  const billingReports = async (query = {}) =>
    await getOtherBillingReport(
      {
        endpoint: "/report/dcs-additional-billing-report",
        query,
      },
      true
    ).unwrap();
  return [billingReports, data];
};

export const useLazyGetOtherMonthlyBillingReport = () => {
  const [getOtherBillingReport, data] = useLazyGetQuery();
  const billingReports = async (query = {}) =>
    await getOtherBillingReport(
      {
        endpoint: "report/other-utility-monthly-billing-report",
        query,
      },
      true
    ).unwrap();
  return [billingReports, data];
};
